// 本登録ウィザードのサブステップ構成（純関数・vitest が直接検証する / tst-szv6.5）。
//
// 保険証券のステップは「保険要件が有効なとき」だけ並ぶ（GET /guides/me/requirements の
// insuranceRequired）。保留中（既定）は 4 ステップになり、表示番号は詰める（1〜4）。
// Step の値そのものは詰めない — 3 は常に保険で、保留中は単に通らない。値を詰めると
// 「同じ 3 が設定によって保険だったり銀行だったりする」ことになり、取り違えの元になる。

export type Step = 1 | 2 | 3 | 4 | 5;

/** 保険証券のステップ。保険要件が保留中は並ばない。 */
export const INSURANCE_STEP: Step = 3;

export type SubStep = { n: Step; label: string };

const ALL_SUB_STEPS: SubStep[] = [
  { n: 1, label: "Contract signature" },
  { n: 2, label: "Anti-social confirmation" },
  { n: INSURANCE_STEP, label: "Insurance certificate upload" },
  { n: 4, label: "Bank info" },
  { n: 5, label: "Emergency contact" },
];

/** いま通るステップの並び。先頭は契約署名、末尾は緊急連絡先（＝提出ボタンが出るステップ）で固定。 */
export function wizardSteps(insuranceRequired: boolean): SubStep[] {
  return insuranceRequired ? ALL_SUB_STEPS : ALL_SUB_STEPS.filter((s) => s.n !== INSURANCE_STEP);
}

/** 次のステップ。末尾ではそのまま（提出は別ボタン）。 */
export function nextStep(current: Step, steps: SubStep[]): Step {
  const i = steps.findIndex((s) => s.n === current);
  return steps[Math.min(steps.length - 1, i + 1)]!.n;
}

/** 前のステップ。先頭ではそのまま。 */
export function prevStep(current: Step, steps: SubStep[]): Step {
  const i = steps.findIndex((s) => s.n === current);
  return steps[Math.max(0, i - 1)]!.n;
}
